module.exports = __webpack_public_path__ + "img/tip_industry_map.f47396da.png";